export const rootpath = () => (location: Location) => location.pathname === "/";

export const pathname = (str: string) => (location: Location) => location.pathname.startsWith(str);
